const soMsgList = () => import('@/views/main/somsg/list/List.vue')
export default {
  path: '/main/soMsg/list',
  name: 'soMsgList',
  component: soMsgList,
  children: []
}
